import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Prevent CRA's red overlay for runtime errors (e.g. ResizeObserver loop). Errors still appear in the console.
try {
  const overlay = require('react-error-overlay');
  const stop = overlay?.stopReportingRuntimeErrors ?? overlay?.default?.stopReportingRuntimeErrors;
  if (typeof stop === 'function') stop();
} catch (_) { /* overlay not available in prod */ }

class AppErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, fontFamily: 'sans-serif', maxWidth: 600 }}>
          <h1 style={{ color: '#c00' }}>Something went wrong</h1>
          <p>{this.state.error?.message || 'Unknown error'}</p>
          <p style={{ fontSize: 12, color: '#666' }}>
            Check the browser console (F12 → Console) for details. Try refreshing or clearing site data for localhost.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);
